import { useAppSelector } from "@grassrootly/rn-core";
import { IGameView } from "@grassrootly/api";

export const useGameView = (id: number): IGameView | null => {
  return useAppSelector((state) => {
    const game = state.gameView.games.find((g: IGameView) => g.game_id === id);
    return game || null;
  });
};

export const useGameViews = (): IGameView[] => {
  return useAppSelector((state) => state.gameView.games);
};
